export const LS_DUBBING_WARNING_MODAL_DISABLED = 'dubbingWarningModalDisabled';
export const LS_SPLIT_SEGMENT_MODAL_DISABLED = 'splitSegmentModalDisabled';
export const MAX_TTS_RATING = 5;
